import {
  ApiException,
  GetGcpSqlVmSetupApi,
  ResponseContext,
  type Configuration,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/gcp-sql-vm';

// The spec declares no body for this operation's error responses, so the generated client throws
// with `body: undefined` and the server's message (e.g. the 409 release-unknown guidance) is lost.
// Read it from the raw response the client passes as the error's cause.
export const withServerErrorBody = async (error: unknown): Promise<unknown> => {
  if (
    !(error instanceof ApiException) ||
    error.body !== undefined ||
    !(error.cause instanceof ResponseContext)
  ) {
    return error;
  }
  const body: unknown = await error.cause.body.json().catch(() => undefined);
  return body === undefined
    ? error
    : new ApiException(error.code, error.message, body, error.headers);
};

export const gcpSqlVm = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const getGcpSqlVmSetupApi = new GetGcpSqlVmSetupApi(config);

  return {
    useGcpSqlVmSetup: (resourceId: string | undefined) =>
      httpClient.executeWithConfig(
        async (projectId: string, id: string) => {
          try {
            return await getGcpSqlVmSetupApi.getGcpSqlVmSetup(projectId, id);
          } catch (error) {
            throw await withServerErrorBody(error);
          }
        },
        resourceId ? baseUrl : null,
        'getGcpSqlVmSetup',
        // A 409 (release not known yet) holds until the next discovery, so retrying in the
        // background only delays the message; the dialog offers a manual retry instead.
        { shouldRetryOnError: false },
        currentProjectId,
        resourceId ?? ''
      ),
  };
};
